import request from '@/utils/request';
export function loginByUsername(username, password, rememberMe, timestamp, validateCode, uuid) {
  if (timestamp) {
    var data = {
      account: username,
      sign: password,
      timestamp: timestamp,
      loginType: '1'
    };
    return request({
      withCredentials: true,
      url: '/auth/login',
      method: 'post',
      data: data
    });
  } else {
    var _data = {
      username: username,
      password: password,
      rememberMe: rememberMe,
      validateCode: validateCode,
      uuid: uuid
    };
    return request({
      withCredentials: true,
      url: '/auth/login',
      method: 'post',
      data: _data
    });
  }
}
export function getUserInfo() {
  return request({
    url: '/uaa/api/account',
    method: 'post'
  });
}
export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  });
} // 无需参数，直接通过保存的accesstoken请求用户信息

export function getLoginUser() {
  return request({
    url: '/userservice/api/user/getLoginUser',
    method: 'post'
  });
} // 无需参数，直接通过保存的accesstoken请求用户菜单

export function getUserMenu() {
  return request({
    url: '/userservice/api/user/getUserMenu',
    method: 'post'
  });
} // 单点登录验证

export function verificationUser(data) {
  return request({
    url: '/pmsservice/api/ExternalApi/LoginSelf',
    method: 'post',
    data: data
  });
}